import React, { Suspense, lazy, useEffect, useState } from 'react';
import config from './config.json'

import Layout from './layout/Layout'
import Login from './login/Login.jsx'
import { useBlockBrowserExit } from './hooks/useBrowserBackButton'
import { resetSessionExpiredState, restoreSession, setSessionExpiredHandler } from './auth/session'
import { topographyViewerIdFromLocation } from './modules/agro/campos/topografia/openViewerTab'

const TopographyViewerPage = lazy(() => import('./modules/agro/campos/topografia/TopographyViewerPage'))

const App = () => {

  const [ ready, setReady ] = useState (false)
  const [ login, setLogin ] = useState(true)

  useBlockBrowserExit(ready && login)

  const topoViewerId = topographyViewerIdFromLocation()

  useEffect(() => {
    setSessionExpiredHandler(() => {
      alert('Su sesion ha caducado. Ingrese nuevamente.')
      setLogin(true)
    })
  }, [])

  useEffect(  () => {

    async function getInitData() {
      
      config.client = await localStorage.getItem('client')

      if (restoreSession()) {
        setLogin(false)
        resetSessionExpiredState()
      }

      setReady(true)
    }

     getInitData()
    
  }, [])
  

  return (
    <div className="App">
      {ready && (
        login === true ? 
          <Login  
            client = { config.client } 
            setLogin = { (value) => {
              if (value === false) resetSessionExpiredState()
              setLogin(value)
            } }       
          />
          : (
            topoViewerId
              ? (
                <Suspense fallback={null}>
                  <TopographyViewerPage topographyId={topoViewerId} />
                </Suspense>
              )
              : <Layout setLogin={setLogin} />
          )
      )
        }
    </div>
  );
}

export default App;
